import FormRule from "../../FormRule.model";

export default class ValidationRule extends FormRule {
    constructor(manager, settings = {}) {
        super(manager, settings);

        this.targets = [];

        if (settings.useEventPool === true) {
            this.getForm().addEventListener('submit', async event => {
                const isValid = await this.check(this.validator);
                if (isValid === false) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                }
            });

        }
    }

    /**
     * Generate a customObject in order to use different scope from each rules
     * @param {string|Node} selector
     */
    createTarget(selector) {
        return {
            element: typeof selector === 'string' ? document.querySelector(selector) : selector,
            isActive: false
        }
    }

    clearValidity() {
        // abstract
    }

    loadTarget(selector) {
        const target = this.createTarget(selector);
        this.targets.push(target);
        return target;
    }

    generateFeedback(elt) {
        let feedbackElt = this.getFeedbackElt(elt);

        if(feedbackElt === null) {
            feedbackElt = document.createElement('div');
            feedbackElt.setAttribute('data-input', elt.getAttribute('name'));
            feedbackElt.setAttribute('data-rule', this.getRuleName());
            feedbackElt.classList.add('invalid-feedback');
            elt.parentNode.insertBefore(feedbackElt, elt.nextSibling);
        }
        return feedbackElt
    }

    setCustomErrorMessage(inputElement, feedbackElement, message) {
        // if (!inputElement.getAttribute('data-lock')) {
        //     // inputElement.reportValidity();
        //     return; // only one error message by element
        // }

        inputElement.setAttribute('data-lock', true);

        inputElement.setCustomValidity(message);
        if (feedbackElement !== null) {
            feedbackElement.textContent = message;
        }
        else {
            inputElement.reportValidity();
        }
    }

    invalidate(eltToInvalidate) {
        const feedbackElt = this.getFeedbackElt(eltToInvalidate);
        const inputId = eltToInvalidate.id;
        const inputName = eltToInvalidate.name;
        const labels = document.querySelectorAll(`label[for='${inputId}']`);
        const spans = document.querySelectorAll(`span[for='${inputName}']`);

        Array.from(labels).forEach(labels => labels.classList.add('is-invalid'));
        Array.from(spans).forEach(spans => spans.classList.add('is-invalid'));
        eltToInvalidate.classList.add('is-invalid');

        this.setCustomErrorMessage(
            eltToInvalidate,
            feedbackElt,
            this.getMessage(eltToInvalidate)
        );
    }

    resetValidity(elt) {
        const feedbackElt = this.getFeedbackElt(elt);
        const inputId = elt.id;
        const inputName = elt.name;
        const labels = document.querySelectorAll(`label[for='${inputId}']`);
        const spans = document.querySelectorAll(`span[for='${inputName}']`);
        Array.from(labels).forEach(labels => labels.classList.remove('is-invalid'));

        Array.from(spans).forEach(spans => spans.classList.remove('is-invalid'));
        if (feedbackElt !== null) {
            feedbackElt.textContent = '';
        }
    elt.removeAttribute('data-lock');

        elt.classList.remove('is-invalid');
        elt.setCustomValidity('');
    }


    listenValidity(target) {
        this.generateFeedback(target.element);

        target.element.addEventListener('input', () => {
            this.resetValidity(target.element);
            target.isActive = true;
        });

        target.element.addEventListener('blur', () => {
            if (target.isActive === true) {
                this.refreshValidity(target);
            }

            target.isActive = false;
        });
    }


    refreshFeedback() {
        this.targets.forEach(target => {
            this.refreshValidity(target);
        });
    }

    refreshValidity(target) {
        let isValid = true;
        if (this.checkOne(target.element) === false) {
            this.invalidate(target.element);
            isValid = false;
        }

        else {
            target.element.setCustomValidity('');
        }

        return isValid;
    }


    getFeedbackElt(elt) {
        const selector = `[data-rule="${this.getRuleName()}"][data-input="${elt.getAttribute('name')}"].invalid-feedback`;
        return this.getForm().querySelector(selector);
    }


    async check() {
        return true;
    }

    checkOne(target) {
        return true;
    }
}
